import React from 'react';
import { Box, Typography } from '@mui/material';

interface PageHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, icon, actions }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 1.5,
      mb: 1.25,
      minHeight: 28,
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0, flex: 1 }}>
      {icon && (
        <Box
          sx={{
            color: '#208040',
            display: 'flex',
            alignItems: 'center',
            flexShrink: 0,
            '& svg': { fontSize: 18 },
          }}
        >
          {icon}
        </Box>
      )}
      <Typography
        sx={{
          fontFamily: '"Montserrat", sans-serif',
          fontSize: '1rem',
          fontWeight: 700,
          lineHeight: 1.2,
          color: 'text.primary',
          flexShrink: 0,
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <>
          <Box
            sx={{
              width: 3,
              height: 3,
              borderRadius: '50%',
              bgcolor: 'text.disabled',
              flexShrink: 0,
              mx: 0.5,
            }}
          />
          <Typography
            noWrap
            sx={{
              fontSize: '0.75rem',
              fontWeight: 400,
              color: 'text.secondary',
              lineHeight: 1.2,
              minWidth: 0,
            }}
          >
            {subtitle}
          </Typography>
        </>
      )}
    </Box>
    {actions && <Box sx={{ flexShrink: 0, display: 'flex', gap: 1 }}>{actions}</Box>}
  </Box>
);

export default PageHeader;
